// src/theme.js
// import { colors } from '@mui/material';
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2', // Primary color (e.g., blue)
    },
    secondary: {
      main: '#ff4081', // Secondary color (e.g., pink)
    },
    sidebar: {
      text: '#1F1F1F', // Text color for sidebar
    },
    header: {
      background: '#ffffff', // Header background color
      text: '#000000', // Header text color
    },
  },
  typography: {
    fontFamily: 'InterTight, sans-serif',
    h6: {
      fontSize: '18px', // Increased font size for headers
      fontWeight: 500,
    },
    subtitle1: {
      fontSize: '16px',
      fontWeight: 500,
    },
    body1: {
      fontSize: '16px',
      fontWeight: 400,
    },
    sidebarHeader: {
      fontSize: '18px',
      fontWeight: 600, // Ensure consistent font weight
    },
    sidebarBody: {
      fontSize: '16px',
      fontWeight: 400,
    },
    sidebarHistoryHeader: {
      fontSize: '16px',
      fontWeight: 500,
    },
    sidebarHistoryHeader2: {
      fontSize: '14px',
      fontWeight: 600,
    },
    sidebarHistoryBody: {
      fontSize: '14px',
      fontWeight: 400,
    },
    relatedHeader: {
      fontSize: '16px',
      fontWeight: 500,
      color: '#132F69',
    },
  },
});

export default theme;
